import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { INDOOR_PARTNERS_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const updateIndoorPartnerAction = createAsyncThunk(
    'pod/updateIndoorPartnerAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.put(`${ INDOOR_PARTNERS_PATH }/${ data.id }`, data.form);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const updateIndoorPartnerSlice = createSlice({
    name: 'updateIndoorPartnerSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(updateIndoorPartnerAction.pending, () => STATE__API__STARTED);
        builder.addCase(updateIndoorPartnerAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(updateIndoorPartnerAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const updateIndoorPartnerState = (state) => state.pod.updateIndoorPartner;
export default updateIndoorPartnerSlice.reducer;